export default "__VITE_ASSET__D$YK4mcr__"